import { ApiFieldError, TodoAny } from 'src/types';
import { actionCreatorFactory } from 'typescript-fsa';

export type APIError = ApiFieldError;
type Assets = TodoAny;

export type CreateAssetsParams = any;
export type DeleteAssetParams = any;
export type UpdateAssetsPayload = Partial<Assets>;

export type UpdateAssetsParams = UpdateAssetsPayload;
/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@manager/assets`);

export const assetsRequest = actionCreator('request');
export const describeAssetsActions = actionCreator.async<any, any, APIError[]>(
  'request-assets'
);
export const assetsRequestSuccess = actionCreator<Assets>('success');

export const assetsRequestFail = actionCreator<APIError[]>('fail');
export const updateAssetsActions = actionCreator.async<
  UpdateAssetsParams,
  Assets,
  APIError[]
>(`update`);

export const createAssetsActions = actionCreator.async<
  CreateAssetsParams,
  any,
  APIError[]
  >(`create`);
export const deleteAssetActions = actionCreator.async<
  DeleteAssetParams,
  any,
  APIError[]
  >(`delete`);
